<script lang="ts">
  import logoBadge from "website_script/assets/images/logo-badge.png"
  import PriceRating from "component_library/components/svelte/PriceRating.svelte"
  import { getContext } from "svelte"
  import type { Settings } from "website_script/types/settings"
  import logo from "icons/autouncleLogoUnconstrained.svg?raw"
  import Svg from "website_script/components/Svg.svelte"
  import { CUSTOM_CSS_NAMES } from "website_script/lib/customCss"
  import { PriceRatingCar } from "website_script/operations/getPriceRatingsForWidget"
  import { trackFunction } from "website_script/lib/tracking"

  export let car: PriceRatingCar

  const { disableSeoLink, priceRatingWidgetMaxWidth } =
    getContext<Settings>("settings")

  const inlineStyle =
    priceRatingWidgetMaxWidth > 0
      ? `max-width: ${priceRatingWidgetMaxWidth}px;`
      : ""

  function trackClick() {
    trackFunction({
      action: "clicked",
      entity: "price_rating_widget",
      element: "logo",
      type: "interacted_with_cta",
    })
  }
</script>

<div
  style={inlineStyle}
  class="au-price-rating-widget__wrapper {CUSTOM_CSS_NAMES.PRICE_RATING_WIDGET_CONTAINER}"
  data-testid="price-rating-widget-wrapper"
>
  <div class="au-price-rating-widget">
    <div
      class="au-price-rating-widget__main"
      data-testid="price-rating-widget-main"
    >
      <img
        src={logoBadge}
        class="au-logo-badge"
        alt="AutoUncle logo in a badge"
      />
      <PriceRating
        layout="vertical"
        rating={car.auRating}
        ratingText={car.ratingText}
      />
    </div>

    {#if disableSeoLink}
      <div class="au-logo__wrapper">
        <Svg alt="AutoUncle" data={logo} height="14" />
      </div>
    {:else}
      <a
        href={car.auCarUrl}
        on:click={trackClick}
        target="_blank"
        class="au-logo__wrapper"
      >
        <Svg alt="AutoUncle" data={logo} height="14" />
      </a>
    {/if}
  </div>
</div>

<style>
  .au-price-rating-widget__wrapper {
    width: 100%;
    min-width: 73px; /* smallest size we would like to support */
    max-width: 252px; /* biggest size we would like to support */
    container: price-rating-widget / inline-size;
  }

  .au-price-rating-widget {
    display: flex;
    flex-direction: column;
    gap: var(--au-spacing-2xs);

    text-decoration: none;

    @container price-rating-widget (min-width: 220px) {
      flex-direction: row;
      flex-wrap: wrap;
      align-items: center;
      gap: 0;
    }
  }

  .au-price-rating-widget :global(.auws-widget-price-rating__text) {
    font-size: var(--au-text-body-xsmall-font-size);

    @container price-rating-widget (min-width: 90px) {
      font-size: var(--au-text-body-small-font-size);
    }
  }

  .au-price-rating-widget__main {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: flex-start;
    gap: var(--au-spacing-2xs);
    flex-shrink: 0;
    flex-grow: 1;
  }

  .au-price-rating-widget > :global(svg) {
    align-self: flex-start !important;
  }

  .au-price-rating-widget img.au-logo-badge {
    display: none !important;
    height: 32px !important;
    width: auto !important;
    /* style leakage fix */
    max-width: none !important;

    @container price-rating-widget (min-width: 140px) {
      display: block !important;
    }
  }

  .au-logo__wrapper {
    width: 100% !important;
    max-width: 100px !important;
    /* To override rules that set svg path color to currentColor */
    color: var(--au-logo-color) !important;

    @container price-rating-widget (min-width: 220px) {
      padding-left: var(--au-spacing-xs) !important;
      flex-shrink: 0 !important;
    }
  }

  .au-logo__wrapper :global(svg) {
    display: block !important;
    max-width: 100% !important;
  }
</style>
